import React, { useState, useEffect } from 'react';
import MyAccountSideBar from '../components/MyAccount/MyAccountSideBar';
import { CommonService } from '../services/common';
import pathObj from '../services/Config';
import { errorHandling } from '../helpers/common';

const Video = () => {
    const [loading, setLoading] = useState(true);
    const [videoData, setVideoData] = useState(null);

    useEffect(() => {
        fetchVideoData();
    }, []);

    const fetchVideoData = async () => {
        try {
            setLoading(true);
            const response = await CommonService.getListing(`${pathObj.baseURL}${pathObj.getFooterInfo}`);
            
            if (response?.success && response?.data) {
                const footerData = response.data.FooterAddress;
                
                // Get video data from indices 11 and 12
                const videoInfo = {
                    title: "Product Video",
                    description: "Watch our product guide video.",
                    videoPath: footerData.video_url?.video_url || `${pathObj.backendURL}/video/sample-video.mp4`,
                    thumbnail: footerData.video_thumb?.video_thumb || `${pathObj.backendURL}/video/video-thumb.png`
                };
                
                setVideoData(videoInfo);
            }
        } catch (error) {
            console.error('Error fetching video data:', error);
            errorHandling(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="container mt-4">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                    <p className="mt-2">Loading video...</p>
                </div>
            </div>
        );
    }

    if (!videoData) {
        return (
            <div className="container mt-4">
                <div className="text-center">
                    <h4>Video Not Available</h4>
                    <p className="text-muted">Unable to load video content.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="cetogry_listing">
            <div className="container">
                <div className="clinner d-flex flex-wrap align-items-start">
                    <MyAccountSideBar />

                    <div className="common_right_block">
                        <div className="contact_details account_details">
                            <div className="common_form">
                                <div className="page-header mb-4">
                                    <h1 className="page-title">Product Video</h1>
                                    <p className="page-description">
                                        Watch our product installation and setup guide video.
                                    </p>
                                </div>

                                {/* Single Video Display */}
                                <div className="row justify-content-center">
                                    <div className="col-lg-12 col-md-10">
                                        <div className="card video-card">
                                            <div className="video-thumbnail position-relative">
                                                <video 
                                                    width="100%" 
                                                    height="auto" 
                                                    controls
                                                    poster={videoData.thumbnail}
                                                    preload="metadata"
                                                >
                                                    <source src={videoData.videoPath} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            </div>
                                            <div className="card-body">
                                                <h3 className="card-title">{videoData.title}</h3>
                                                <p className="card-text">{videoData.description}</p>
                                                {/* <div className="video-meta">
                                                    {videoData.duration && (
                                                        <small className="text-muted">
                                                            <i className="fas fa-clock me-1"></i>
                                                            Duration: {videoData.duration}
                                                        </small>
                                                    )}
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Video;